var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFrownyFace = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 25.6668C12.3333 25.6668 14.8333 22.3335 18.9999 22.3335C23.1666 22.3335 25.6666 25.6668 25.6666 25.6668M13.9999 14.0002H14.0166M23.9999 14.0002H24.0166M35.6666 19.0002C35.6666 28.2049 28.2047 35.6668 18.9999 35.6668C9.79517 35.6668 2.33325 28.2049 2.33325 19.0002C2.33325 9.79542 9.79517 2.3335 18.9999 2.3335C28.2047 2.3335 35.6666 9.79542 35.6666 19.0002Z",
    stroke: "url(#paint0_linear_455_870)",
    strokeWidth: 3.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_455_870",
    x1: 31.2369,
    y1: 15.6668,
    x2: 16.7791,
    y2: 12.9987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DB9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0042E5"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFrownyFace, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/frowny-face.9ec10360.svg";
export { ForwardRef as ReactComponent };